import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Header extends React.PureComponent {
    static propTypes = {};

    state = {};

    // 全站渠道标记传递，文章页的任意跳转

    render() {
        return (
            <div className={styles.header}>
                <div className={'w1000'}>
                    <img
                        src="https://p0.ifengimg.com/ifeng/index/20150921/ifengLogo.png"
                        style={{ marginTop: '4px' }}
                        width="115"
                        height="41"
                        title="凤凰网"
                        alt="凤凰网"
                    />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
